/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSyncEntitiesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {GetSyncEntitiesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const serviceGetSyncEntities = (request:GetSyncEntitiesRequest, options?: CashRequestOptions) => post<GetSyncEntitiesRequest, GetSyncEntitiesResponse>("/2.0/cash/service-get-sync-entities", request, {...options, rejectOnError: true })